import { useEffect, useState } from "react";
import styled from "styled-components";

import { API_CALLS } from "../../../../../../API/api_calls";
import { useAppSelector } from "../../../../../../redux";
import { Modal } from "../../../../../Common/Modal";
import { FlexColumn } from "../../../../../Common/Styles";
import { AvatarGroupAndDescription } from "./AvatarGroupAndDescription";
import { PeopleYouMightKnowModalContent } from "./PeopleYouMightKnowModalContent";
import { TitleAndButton } from "./TitleAndButton";

export const PeopleYouMightKnow = () => {
  const { peopleYouMightKnow_API_STATUS } = useAppSelector((state) => state.me);
  const [showPeopleYouMightKnowModal, setShowPeopleYouMightKnowModal] =
    useState(false);

  useEffect(() => {
    if (peopleYouMightKnow_API_STATUS !== "idle") return;

    API_CALLS.ME.getPeopleYouMightKnow();
  }, [peopleYouMightKnow_API_STATUS]);

  return (
    <Container className="people-user-might-know">
      <TitleAndButton
        onIconButtonClick={() => setShowPeopleYouMightKnowModal(true)}
      />
      <AvatarGroupAndDescription
        onClick={() => setShowPeopleYouMightKnowModal(true)}
      />
      {showPeopleYouMightKnowModal && (
        <Modal
          from="people-you-might-know"
          type="Pages"
          showCloseButton={true}
          setCloseButton={setShowPeopleYouMightKnowModal}
          stretchToFullWidth={true}
          padding={32}
          gap={16}
          zIndex={6}
        >
          <PeopleYouMightKnowModalContent />
        </Modal>
      )}
    </Container>
  );
};

const Container = styled(FlexColumn)`
  position: relative;
  gap: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  box-shadow: ${({ theme }) => theme.boxShadows["box-shadow-s"]};
  padding: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  border-radius: ${({ theme }) => theme.radius["radius-xxs"].value}rem;
  background: linear-gradient(45deg, #ffffff 10%, #1e96f20a 108%);
`;
